import { Row, Col, Card, Image } from 'react-bootstrap';
import PageWrapper from '../../components/PageWrapper';
import {
  FaCheckCircle,
  FaUserMd,
  FaFlask,
  FaProcedures,
  FaNotesMedical,
  FaHeartbeat,
} from 'react-icons/fa';

const PageStructure = ({ data }) => {
  const featureIcons = [
    FaCheckCircle,
    FaUserMd,
    FaFlask,
    FaNotesMedical,
    FaHeartbeat,
  ];
  return (
    <PageWrapper PageWrapper title={data.maintitle}>
      <div className="py-4">
        <div className="text-center my-4">
          <h1 className="fw-bold">{data.title}</h1>
          <p className="mt-2 primary-class ">{data.subtitle}</p>
        </div>

        {data.banner && (
          <div className="d-flex justify-content-center mb-5 px-3">
            <Image
              src={data.banner}
              className="w-100 img-fluid shadow-sm"
              style={{
                width: '100%',
                maxWidth: '1200px',
                height: 'auto',
                borderRadius: '12px',
              }}
            />
          </div>
        )}

        <div className="pb-3">
          {data.riskSection && (
            <Card className="p-2 mb-5 border-0">
              <Row className="align-items-center">
                {/* LEFT SIDE */}
                <Col lg={5}>
                  {data.riskSection.kicker && (
                    <div className="primary-class small fw-bold mb-2">
                      {data.riskSection.kicker}
                    </div>
                  )}

                  <h3 className="fw-bold">{data.riskSection.title}</h3>
                  <p className="text-muted mt-3 ">{data.riskSection.text}</p>

                  <div className="my-5 d-flex justify-content-center justify-content-lg-start">
                    <Image
                      src={data.riskSection.doctorsImg}
                      fluid
                      rounded
                      style={{
                        width: '80%',
                        maxWidth: '350px',
                      }}
                    />
                  </div>
                </Col>

                {/* RIGHT SIDE */}
                <Col md={7}>
                  <Row className="g-3">
                    {data.riskSection.boxes.map((box, i) => (
                      <Col sm={6} key={i}>
                        <Card
                          className="p-4 shadow-sm h-100"
                          style={{ borderRadius: '12px' }}
                        >
                          {/* NUMBER + LINE (EXACT LIKE IMAGE) */}
                          <div className="d-flex align-items-center mb-3">
                            <span className="fw-bold fs-5 primary-class me-2">
                              {String(i + 1).padStart(2, '0')}
                            </span>
                            <span
                              style={{
                                height: '3px',
                                width: '35px',
                                backgroundColor: '#0a7884',
                                display: 'inline-block',
                                borderRadius: '5px',
                              }}
                            ></span>
                          </div>

                          {/* HEADING */}
                          <div className="fw-bold mb-1">{box.title}</div>

                          {/* DESCRIPTION */}
                          <p className="text-muted small mb-0">{box.text}</p>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </Card>
          )}
        </div>

        {/* ISSUE SECTION (Exact same as image) */}
        <Row className="align-items-center my-3 px-3">
          <Col md={6}>
            {/* Kicker */}
            {data.issueSection.kicker && (
              <div className="primary-class small fw-bold mb-2">
                {data.issueSection.kicker}
              </div>
            )}

            {/* Title + Subtitle */}
            <h2 className="fw-bold">
              {data.issueSection.title} <br />
              {data.issueSection.subtitle}
            </h2>

            {/* Features List */}
            <div className="mt-4">
              {data.issueSection.features.map((item, idx) => {
                const Icon = featureIcons[idx % featureIcons.length]; // auto-cycle icons

                return (
                  <div key={idx} className="d-flex align-items-start mb-4">
                    {/* Icon Box */}
                    <div
                      className="d-flex align-items-center justify-content-center rounded-3 me-3 "
                      style={{
                        width: '50px',
                        height: '50px',
                        backgroundColor: '#E5F3F3',
                        minWidth: '50px',
                      }}
                    >
                      <Icon size={26} color="#2A8C8C" />
                    </div>

                    {/* Texts */}
                    <div>
                      <div className="fw-bold">{item.title}</div>
                      <div className="text-muted small">{item.description}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>

          <Col md={6} className="d-flex justify-content-center">
            <Image
              src={data.issueSection.image}
              fluid
              rounded
              className="shadow-sm"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Col>
        </Row>

        {/* 5️⃣ OPD MEDICINE SERVICE BOXES (3 equal cards with icon) */}
        <div className="text-center my-5">
          <h3 className="fw-bold mb-4">OPD Medicine & Service Advice</h3>
        </div>

        <Row className="g-4 pb-5">
          {data.opdAdvice.map((item, idx) => {
            const IconComponent =
              idx === 0 ? FaUserMd : idx === 1 ? FaFlask : FaProcedures;

            return (
              <Col md={4} key={idx} className="px-4">
                <Card className="p-2 shadow-sm h-100 border-2 rounded-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center mb-3 rounded-3"
                    style={{
                      width: '60px',
                      height: '60px',
                      backgroundColor: '#E5F3F3',
                    }}
                  >
                    <IconComponent size={28} color="#2A8C8C" />
                  </div>

                  <h6 className="fw-semibold text-start">{item.title}</h6>
                  <p className="text-muted small text-start mt-2">
                    {item.text}
                  </p>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </PageWrapper>
  );
};

export default PageStructure;
